import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useParams } from 'react-router';

import useStores from '../../../../../hooks/useStores';
import useSinglePatientService from '../../../../../Pages/SinglePatientDetails/Service';
import { invalidatePatientOverviewData } from '../../../../patientOverviewData';

export default function useDischargeService() {
  const queryClient = useQueryClient();
  const { patientUuid = '' } = useParams<{ patientUuid: string }>();
  const { refetch } = useSinglePatientService(patientUuid);
  const {
    patientsServiceStore: { queryKey },
  } = useStores();

  const dischargeAction = useMutation({
    mutationFn: async (endDate: string) => {
      await axios.post(`/api/camel/patient_profile/administration/${patientUuid}/discharge`, {
        end: endDate,
      });
      await invalidateAdministrationQuery();
      await refetchPatientQuery();
      await invalidatePatientsQueries();
    },
  });

  const invalidateAdministrationQuery = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['camel', 'patient_profile', 'administration', patientUuid],
    });
  };

  const refetchPatientQuery = async () => {
    refetch();
    invalidatePatientOverviewData(queryClient, patientUuid);
  };

  const invalidatePatientsQueries = async () => {
    await queryClient.invalidateQueries({ queryKey });
  };

  return {
    discharge: dischargeAction.mutateAsync,
    invalidateAdministrationQuery,
  };
}
